<template>
  <div id="adminDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg4 sm6 xs12 class="mb-4">
           <router-link to="/admin/messages">
           <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title to="/" class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon large class="pf-text-green">message</v-icon>
                  </div>
                  <h4 xs6>New Messages: <span>{{ AdminDashboardCounts.Messages }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex lg4 sm6 xs12 class="mb-4">
          <router-link to="/admin/families">
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title to="/" class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon large :class="{ 'pf-text-green': AdminDashboardCounts.All, 'pf-text-red': !AdminDashboardCounts.All }">people</v-icon>
                  </div>
                  <h4 xs6>Clients: <span>{{ AdminDashboardCounts.All || 0 }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex lg4 sm6 xs12 class="mb-4">
          <router-link to="/admin/surveys">
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title to="/" class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon large :class="{ 'pf-text-green': AdminDashboardCounts.Survey, 'pf-text-red': !AdminDashboardCounts.Survey }">feedback</v-icon>
                  </div>
                  <h4 xs6>Survey: <span>{{ AdminDashboardCounts.Survey }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex lg3 sm6 xs12 class="mb-4">
          <router-link to="/admin/families/New" >
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon :class="{ 'pf-text-green': AdminDashboardCounts.New, 'pf-text-red': !AdminDashboardCounts.New }">new_releases</v-icon>
                  </div>
                  <h4 xs6>New: <span>{{ AdminDashboardCounts.New || 0 }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex lg3 sm6 xs12 class="mb-4">
          <router-link to="/admin/families/Writing" >
            <v-card hover>
              <v-layout>
                <v-flex>
                  <v-card-title to="/" class="justify-space-around" primary-title>
                    <div xs6 class="icon">
                      <v-icon :class="{ 'pf-text-green': AdminDashboardCounts.Writing, 'pf-text-red': !AdminDashboardCounts.Writing }">create</v-icon>
                    </div>
                    <h4 xs6>Writing: <span>{{ AdminDashboardCounts.Writing || 0 }}</span></h4>
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-card>
          </router-link>
        </v-flex>
        <v-flex lg3 sm6 xs12 class="mb-4">
          <router-link to="/admin/families/Layout" >
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon :class="{ 'pf-text-green': AdminDashboardCounts.Layout, 'pf-text-red': !AdminDashboardCounts.Layout }">book</v-icon>
                  </div>
                  <h4 xs6>Layout: <span>{{ AdminDashboardCounts.Layout || 0 }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex lg3 sm6 xs12 class="mb-4">
          <router-link to="/admin/families/Video" >
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-title to="/" class="justify-space-around" primary-title>
                  <div xs6 class="icon">
                    <v-icon :class="{ 'pf-text-green': AdminDashboardCounts.Video, 'pf-text-red': !AdminDashboardCounts.Video }">videocam</v-icon>
                  </div>
                  <h4 xs6>Video: <span>{{ AdminDashboardCounts.Video || 0 }}</span></h4>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/* global session store moment */
import { getCollection } from '../helpers/helpers';

export default {
  components: {
  },
  data: () => ({
    // Data properties can be added here if needed
  }),
  computed: {
    AdminDashboardCounts: {
      set (value) {
        store.commit('setAdminDashboardCounts', value);
      },
      get () {
        return store.state.AdminDashboardCounts;
      }
    },
    CountsLoaded: {
      get () {
        return store.state.CountsLoaded;
      },
      set (value) {
        store.commit('setCountsLoaded', value);
      }
    }
  },
  async created () {
    const header = document.getElementById('pageHeader');
    if (header) {
      window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);
    }
    await this.getCounts();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async getCounts () {
      if (!this.CountsLoaded) {
        let { error, data, count } = await getCollection('Agency/Counts', true, 0);
        if (error) {
          console.log(error);
        } else {
          this.CountsLoaded = true;
          this.AdminDashboardCounts = data;
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/AdminDashboard.vue